import { combineTokens } from '@utils/css';

const tokens = combineTokens("--text-export--glossary", {
  columnCount: 1
});
const glossaryContainer = "_rsg18q3cjc";

export { glossaryContainer, tokens };
import "./page.glossary-words.style.linaria.module.css";
//# sourceMappingURL=page.glossary-words.style.js.map
